import { makeStyles } from '@mui/styles';
import { colors, fontWeight } from '../../../packages';

export const sxStyles = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 3,
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  totalCount: {
    fontSize: '14px',
    color: colors.neutral900,
    marginLeft: 1.5,
    fontWeight: fontWeight.SEMI_BOLD,
    backgroundColor: colors.white,
    border: `1px solid ${colors.neutral200}`,
    borderRadius: '24px',
    padding: '4px 12px',
    display: 'inline-flex',
    alignItems: 'center',
  },
  tableContainer: {
    backgroundColor: colors.white,
    borderRadius: 1,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
  },
};

export const useStyles = makeStyles({
  title: { fontFamily: 'Source Serif Pro' },
  addConstructBtn: {
    height: 64,
    color: '#FFF',
    whiteSpace: 'nowrap',
    padding: '20px 24px',
    borderRadius: 8,
  },
  actionMenu: {
    display: 'flex',
    justifyContent: 'center',
    width: '32px',
  },
});
